$(document).ready(function(){

  $(document).on("click", ".update_online_auction_price_list", function(){
    var price_step_count = $("#price_step_count").val();
    if($(this).val() == "true"){
      for (i = 1; i <= price_step_count; i += 1) {
        $('#input_add_min_price_'+i).prop('disabled', false);
        $('#input_add_max_price_'+i).prop('disabled', false);
        $('#input_add_ad_price_'+i).prop('disabled', false);
      }
    }else{
      for (i = 1; i <= price_step_count; i += 1) {
        $('#input_add_min_price_'+i).prop('disabled', true);
        $('#input_add_max_price_'+i).prop('disabled', true);
        $('#input_add_ad_price_'+i).prop('disabled', true);
      }
    }
  });

  $(document).on("click", ".update_auction_notice_price_list", function(){
    if($(this).val() == "true"){
      $('#user_auction_notice_price_list').prop('disabled', false);
    }else{
      $('#user_auction_notice_price_list').prop('disabled', true);
    }
  });

  $(document).on("click", ".update_sales_ad_price_list", function(){
    if($(this).val() == "true"){
      $('#sales_ad_one_period').prop('disabled', false);
      $('#sales_ad_two_period').prop('disabled', false);
      $('#sales_ad_three_period').prop('disabled', false);
      $('#sales_ad_one_price').prop('disabled', false);
      $('#sales_ad_two_price').prop('disabled', false);
      $('#sales_ad_three_price').prop('disabled', false);
    }else{
      $('#sales_ad_one_price').prop('disabled', true);
      $('#sales_ad_two_price').prop('disabled', true);
      $('#sales_ad_three_price').prop('disabled', true);
      $('#sales_ad_one_period').prop('disabled', true);
      $('#sales_ad_two_period').prop('disabled', true);
      $('#sales_ad_three_period').prop('disabled', true);
    }
  });

  $(document).on("click", ".active_private", function(){
    $('.active_private').addClass('btn-primary');
    $('.active_company').removeClass('btn-primary');
    $("#user_customer_type").val("PRIVATE");
    $( "#company_info" ).addClass( "hide" );
    $( "#company_other_info" ).addClass( "hide" );
    $( "#private_info" ).removeClass( "hide" )
  });

  $(document).on("click", ".active_company", function(){
    $('.active_company').addClass('btn-primary');
    $('.active_private').removeClass('btn-primary');
    $("#user_customer_type").val("COMPANY");
    $( "#private_info" ).addClass( "hide" );
    $( "#company_info" ).removeClass( "hide" );
    $( "#company_other_info" ).removeClass( "hide" );
  });

  $(document).on("click", ".seller_user_type", function(){
   if($(this).val() == "ONE_TIME_SELLER"){
    $("#trusted_seller_info").addClass("hide");
    $("#trusted_seller_service_prices_info").addClass("hide");
   } else {
    $("#trusted_seller_info").removeClass("hide");
    $("#trusted_seller_service_prices_info").removeClass("hide");
   }
  });

  $('.img-wrap .close').on('click', function() {
      alert('remove picture: ');
  });

  $(document).on('click', '.show_image_loader', function(){
    $("#loader-image").show();
  });
});